import {z} from 'zod'

//const boolEnvVar = z.literal('true').or(z.literal('false')).transform(value => value == 'true')

export const envVars = z
    .object({
        VITE_APP_TITLE: z.string().optional(),
        VITE_API_ENDPOINT: z.string().url(),
        VITE_GOOGLE_API_KEY: z.string(),
        VITE_WS_ENDPOINT: z.string().url(),
        VITE_APP_VERSION: z.string().optional(),
        // Account deletion request → Google Apps Script Web App (stopgap until the backend endpoint exists)
        VITE_DELETION_SHEET_URL: z.string().url(),
        VITE_DELETION_SHEET_SECRET: z.string().min(1)
    })
    .parse(import.meta.env)
